import React from 'react';
import { View, Text, ScrollView, StyleSheet } from 'react-native';
import { Card } from 'react-native-elements';

export default function HowToScreen() {
  return (
    <ScrollView style={styles.container}>
      <Text style={styles.title}>Welcome to The Best App Ever!</Text>
      
      <Card containerStyle={styles.card}>
        <Text style={styles.cardTitle}>Training Mode</Text>
        <Text style={styles.text}>
          • Practice sight words at your own pace{'\n'}
          • Get instant feedback on pronunciation{'\n'}
          • Track your progress over time{'\n'}
          • Unlock new word sets as you improve{'\n'}
          • Customize your learning experience
        </Text>
      </Card>

      <Card containerStyle={styles.card}>
        <Text style={styles.cardTitle}>Games</Text>
        <Text style={styles.text}>
          • Compete with friends and family{'\n'}
          • Play fun word recognition games{'\n'}
          • Earn badges and achievements{'\n'}
          • Join multiplayer challenges{'\n'}
          • Track your high scores
        </Text>
      </Card>

      <Card containerStyle={styles.card}>
        <Text style={styles.cardTitle}>Getting Started</Text>
        <Text style={styles.text}>
          1. Create an account or continue as guest{'\n'}
          2. Start with Training Mode to learn the basics{'\n'}
          3. Practice regularly to build confidence{'\n'}
          4. Challenge yourself with games{'\n'}
          5. Track your progress in your profile
        </Text>
      </Card>

      <Card containerStyle={styles.card}>
        <Text style={styles.cardTitle}>Tips for Success</Text>
        <Text style={styles.text}>
          • Practice for short periods regularly{'\n'}
          • Use the audio feedback to improve{'\n'}
          • Challenge yourself with new words{'\n'}
          • Celebrate your progress{'\n'}
          • Have fun while learning!
        </Text>
      </Card>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
    marginVertical: 20,
    color: '#4CAF50',
  },
  card: {
    borderRadius: 10,
    marginHorizontal: 10,
    marginBottom: 15,
  },
  cardTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#4CAF50',
  },
  text: {
    fontSize: 16,
    lineHeight: 24,
    color: '#333',
  },
}); 